import { ContractedBusinessScenarioIds } from '@qv-bid/entities';

export class DrugLockUpdate {
  constructor(public readonly cbScenarioIds: ContractedBusinessScenarioIds[], public readonly locked: boolean) {}
}
